module.exports = __webpack_public_path__ + "static/media/payment.58a4a7e8.png";